import { maxTextLines } from 'Shared/frontend/Poster';
import { useProxyProductionImages } from 'Shared/common/ProxyProductionImagesProvider';
import { useUrls } from 'Shared/UrlProvider';
import { css } from '@emotion/css';
import { For } from 'solid-js';
import { Show } from 'solid-js';
import { genreList } from 'Shared/common/Macros';
import { palette } from 'Shared/frontend/SettingsProvider';
import { DateTitle } from 'Shared/frontend/PosterTitle';
import { fonts } from 'Shared/frontend/SettingsProvider';


export const commonGenresStyle = () => css({
	textTransform: 'lowercase',
	lineHeight: 2,
	fontSize: '0.7em',
	...maxTextLines(2),

});

export function actImageUrl(image)
{
	if (!image?.hash)
		return '';
	return useUrls().createVenueImageUrl(image.hash,image,'Lineup-image','medium',useProxyProductionImages());
}


export function FallbackMusicPoster(P)
{
	/* Drawn inside the space the poster was given rather than around it: '100%' against the global
	   border-box leaves the frame's own size untouched. */
	const borderStyle = () => css({
		width: '100%',
		height: '100%',
		border: `6px dotted ${palette().feature}`
	});

	const posterStyle = () => css({
		margin: '24px 0.2em 0 0.2em',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: 14,
		textAlign: 'center',
		color: palette().text
	});

	const eventNameStyle = () => css({
		textTransform: 'uppercase',
		padding: '.5em 0 .5em 0',
		width: '100%',
		...maxTextLines(3),
		fontSize: 18
	});

	return (
		<div class={borderStyle()}>
			<DateWrap {...P}>
				<div class={posterStyle()}>
					<Show when={P.name}>
						<div class={eventNameStyle()}>{ P.name }</div>
					</Show>

					<For each={P.lineup}>{item =>
						<Artist {...item} />
					}</For>
				</div>
			</DateWrap>
		</div>
	);
}

function Artist(P)
{
	const artistNameStyle = () => css({
		width: '100%', 
		fontSize: 16
	});

	const artistStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch'
	});

	const genresStyle = () => css(commonGenresStyle(), {
		fontSize: '0.7em'
	});

//TODO larger fonts for fewer acts 
//TODO add a border

	return (
		<div class={artistStyle()}>
			<Show when={P.name}>
				<div class={artistNameStyle()}>{P.name}</div>
			</Show>
			<Show when={P.mainGenre}>
				<div class={genresStyle()}>{ genreList(P) }</div>
			</Show>
		</div>
	);
}

const dateStyle = () => css({
	fontFamily: fonts().heading,
	width: '100%',
	padding: '0.5em',
	textTransform: 'uppercase',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	// changed from set height to allow for 2nd line for Monthly dates, it will push uploaded poster down
	minHeight: 43.2,
	color: palette().feature
});

export function DateWrap(P)
{
	const dateWrapStyle = css({
		width: 'inherit',
		height: 'inherit',
		display: 'flex !important',
		flexDirection: 'column',
		alignItems: 'stretch',
	});

	return (
		<div class={dateWrapStyle}>
			<div class={dateStyle()}>
				{P.times.customLabel ?? <DateTitle {...P.times}/> }
			</div>

			{ P.children }
		</div>
	);
}

